import {Form, Input, Modal, ModalProps} from "antd";
import {useEffect, useState} from "react";
import BaseDataSelect from "../../../components/BaseDataSelect";
import {useForm} from "antd/lib/form/Form";

interface BusinessConfirmModalProps extends ModalProps {
    orderType?: string
    onFinish: Function
}

function BusinessConfirmModal(props: BusinessConfirmModalProps) {

    const [form] = useForm();

    const orderType = Form.useWatch('orderType', form);

    useEffect(() => {
        form.setFieldValue('orderType', props.orderType);
    }, [props.orderType, props.open]);

    const onOk = (e: any) => {
        if (!!form.getFieldValue('orderType')) {
            props.onFinish?.(form.getFieldValue('orderType'), form.getFieldValue('associateNum'));
        }
    }

    return <Modal {...props} title={'商务确认'} width={600} onOk={onOk}>
        <p style={{color: 'var(--danger-color)'}}>请确认当前订单类型是否准确，如需调整请通过下拉框选择正确的订单类型。</p>
        <br/>
        <Form form={form} layout={'vertical'}>
            <Form.Item label={'订单类型'} name={'orderType'} rules={[{required: true}]}>
                <BaseDataSelect name={'orderTypes'} appendNull={false}/>
            </Form.Item>
            {orderType === '换货订单' && (
                <Form.Item label={'关联单号'} name={'associateNum'}
                           rules={[{required: true, message: '请输入关联单号'}]}>
                    <Input/>
                </Form.Item>
            )}
        </Form>
    </Modal>
}

export default BusinessConfirmModal;

